import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/reconditioner-center-links/:reconditionerCenterLinkId',
    name: 'reconditionerCenterLinkDetail',
    component: () =>
      import(
        '@/views/restricted/recycling-module/reconditioner/reconditioner-center/reconditioner-center-link/ReconditionerCenterLinkDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/reconditioner-centers/:reconditionerCenterId/links/create',
    name: 'reconditionerCenterLinkCreate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/reconditioner/reconditioner-center/reconditioner-center-link/ReconditionerCenterLinkCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_CREATE'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/reconditioner-center-links/:reconditionerCenterLinkId/edit',
    name: 'reconditionerCenterLinkUpdate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/reconditioner/reconditioner-center/reconditioner-center-link/ReconditionerCenterLinkUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_UPDATE'],
      menuSelected: 'recycling'
    }
  }
]
